export default __webpack_public_path__ + "static/media/pool-vehicle.d1f11510.svg";